import { NO_SEARCH_TERMS_SUBMITTED } from 'NewAngular/constants/errors.constants';
import * as i0 from "@angular/core";
export class IntegrationSearchModalBase {
    constructor() {
        this.registrationId = undefined;
        this.submitted = false;
        this.loading = false;
        this.errorMessage = '';
        this.searchTerms = '';
    }
    submit(..._args) {
        // If there are no search terms, throw an error to stop execution in subclasses that use this method in their
        // override. Since it is an expected error, the Sentry error handler is configured to ignore it.
        if (this.searchTerms.trim() === '')
            throw new Error(NO_SEARCH_TERMS_SUBMITTED);
        this.loading = true;
        this.submitted = true;
        this.errorMessage = '';
    }
    submitHandler() {
        this.loading = true;
        this.errorMessage = '';
    }
    importedHoldingsRedirectQueryParams(res) {
        return this.registrationId !== undefined
            ? {
                importedHoldingsId: res.importHoldingsId,
                registrationId: this.registrationId,
            }
            : { importedHoldingsId: res.importHoldingsId };
    }
}
IntegrationSearchModalBase.ɵfac = function IntegrationSearchModalBase_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntegrationSearchModalBase)(); };
IntegrationSearchModalBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IntegrationSearchModalBase, inputs: { registrationId: "registrationId" } });
